import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShipmentListComponent } from './shipment-list/shipment-list.component';
import { ShipmentDetailsComponent } from './shipment-details/shipment-details.component';
import { ShipperComponent } from './shipper/shipper.component';
import { ReceiverComponent } from './receiver/receiver.component';
import { LineItemComponent } from './line-item/line-item.component';
import { PieceComponent } from './piece/piece.component';
import { ShipmentInfoComponent } from './shipment-info/shipment-info.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { CoreModule } from 'src/app/core/core.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { ShipmentHistoryComponent } from './shipment-history/shipment-history.component';
import { MatDialogModule } from '@angular/material/dialog';
import { BillingDetailsComponent } from './billing-details/billing-details.component';

@NgModule({
  declarations: [
    ShipmentListComponent,
    ShipmentDetailsComponent,
    ShipperComponent,
    ReceiverComponent,
    LineItemComponent,
    PieceComponent,
    ShipmentInfoComponent,
    InvoiceComponent,
    ShipmentHistoryComponent,
    BillingDetailsComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    MatDialogModule,
  ],
})
export class ShipmentModule {}
